module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_306359.045de1b3.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/ift/InternetSat/FormatoSimplificado_306359.pdf
// module id = 335
// module chunks = 0